import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_TASKCATEGORY,
  DELETE_TASKCATEGORY,
  UPDATE_TASKCATEGORY,
  ADD_NEW_TASKCATEGORY,
} from "./actionType";

import {
  getTaskCategorySuccess,
  getTaskCategoryFail,
  deleteTaskCategorySuccess,
  deleteTaskCategoryFail,
  updateTaskCategorySuccess,
  updateTaskCategoryFail,
  addTaskCategorySuccess,
  addTaskCategoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveTaskCategoryApi,
  getTaskCategoryApi,
  updateTaskCategoryApi,
  deleteTaskCategoryApi,
  addNewTaskCategoryApi,
} from "../../helpers/backend_helper";

function* getTaskCategory({ payload: taskCategory }) {
  try {
    const response = yield call(getTaskCategoryApi, taskCategory);
    yield put(getTaskCategorySuccess(GET_TASKCATEGORY, response.data));
  } catch (error) {
    yield put(getTaskCategoryFail(GET_TASKCATEGORY, error));
  }
}

function* onUpdateTaskCategory({ payload: taskCategory }) {
  try {
    if (taskCategory.setApprove) {
      const response = yield call(approveTaskCategoryApi, taskCategory);
      yield put(updateTaskCategorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateTaskCategoryApi, taskCategory);
      yield put(updateTaskCategorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTaskCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTaskCategory({ payload: taskCategory }) {
  try {
    const response = yield call(deleteTaskCategoryApi, taskCategory);
    yield put(deleteTaskCategorySuccess({ taskCategory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTaskCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTaskCategory({ payload: taskCategory }) {
  try {
    const response = yield call(addNewTaskCategoryApi, taskCategory);
    yield put(addTaskCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTaskCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetTaskCategory() {
  yield takeEvery(GET_TASKCATEGORY, getTaskCategory);
}

export function* watchUpdateTaskCategory() {
  yield takeEvery(UPDATE_TASKCATEGORY, onUpdateTaskCategory);
}

export function* watchDeleteTaskCategory() {
  yield takeEvery(DELETE_TASKCATEGORY, onDeleteTaskCategory);
}

export function* watchAddNewTaskCategory() {
  yield takeEvery(ADD_NEW_TASKCATEGORY, onAddNewTaskCategory);
}

function* taskCategorySaga() {
  yield all([
    fork(watchGetTaskCategory),
    fork(watchDeleteTaskCategory),
    fork(watchUpdateTaskCategory),
    fork(watchAddNewTaskCategory),
  ]);
}

export default taskCategorySaga;
